module.exports = __webpack_public_path__ + "static/img/word.d033f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/word.png
// module id = /aB/
// module chunks = 1